import { Form, Input } from 'antd'
import gql from 'graphql-tag'
import * as React from 'react'
import { BulkDeleteButton, Datagrid, DateField, Filter, List, SearchInput, TextField, TopToolbar } from 'react-admin'
import { CreateButton } from 'shared/molecules/modal/CreateButton'
import { AccountListActions } from './actions'
// import { QuickFilter } from 'dash/shared';

const AccountFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    {/* <QuickFilter source="status" label="Customers" defaultValue={'active'} /> */}
    {/* <QuickFilter source="status" label="Churned Customers" defaultValue={'churned'} /> */}
  </Filter>
)

export const AccountList = () => (
  <List exporter={false} filters={<AccountFilter />} actions={<AccountListActions />} perPage={25}>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <DateField source="createdAt" />
    </Datagrid>
  </List>
)
